import { useMemo } from 'react'

import { type CardMapType } from '@/defs/card'
import { type ClipboardCardType } from '@/defs/clipboard'
import { type RecType } from '@/defs/rec'
import { useCardMap } from '@/hooks/useCardMap'
import { useReduxSelector } from '@/store/hooks'

type Props = {
  enabled?: boolean
}

const parseRecsFromClipboard = (cards: ClipboardCardType[], cardMap: CardMapType): RecType[] =>
  cards.map(({ cardId, isCommander }) => ({
    cardId,
    name: cardMap[cardId]?.name || '',
    role: isCommander ? 'commander' : undefined,
  }))

export const useClipboard = ({ enabled }: Props = {}) => {
  const preload = useReduxSelector((s) => s.view.clipboardPreload)
  const cards = useReduxSelector((s) => s.clipboard.cards)
  const cardsPending = useReduxSelector((s) => s.clipboard.cardsPending)
  const cardIds = useMemo(() => cards.map((c) => c.cardId), [cards])
  const cardPendingIds = useMemo(() => cardsPending.map((c) => c.cardId), [cardsPending])
  const { cardMap, loading } = useCardMap({
    cardIds: [...cardIds, ...cardPendingIds],
    enabled: enabled || preload,
  })

  const recs = useMemo(() => parseRecsFromClipboard(cards, cardMap), [cards, cardMap])
  const recsPending = useMemo(() => parseRecsFromClipboard(cardsPending, cardMap), [cardsPending, cardMap])

  return { cardIds, cardMap, loading, recs, recsPending }
}
